module.exports = __webpack_public_path__ + "img/building.4c0960b3.svg";